module.exports = __webpack_public_path__ + "img/Bukovel.a9d88064.jpg";